export const ADD_SCHOOLSESSION = "ADD_SCHOOLSESSION";
export const UPDATE_SCHOOLSESSION = "UPDATE_SCHOOLSESSION";
export const RESET_SCHOOLSESSIONS = "RESET_SCHOOLSESSIONS";
